// this file is overwritten by scripts/write-version.js on deploy
export default {
  data() {
    return {
      cuonaManagerVersion: 'production-v1.11.4-d3f3f174',
      cuonaManagerEnvironment: 'unknown(branch)'
    };
  }
};
